import React, { useEffect, useRef, useState } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MenuIcon from '@mui/icons-material/Menu';
import '../../styles/Common/Header.scss';
import MobileMenu from './Menu';

const ModalHeader = ({ onBackClick = () => { }, headerText, showHamburger = false, onHamburgerClick, showBackArrow = false, icons = [], subHeader = '' }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const iconRef = useRef()
    const [iconWidth, setIconWidth] = useState(0)
    useEffect(() => {
        if (iconRef?.current && icons?.length > 0) {
            setIconWidth(iconRef.current?.getBoundingClientRect()?.width)
        }
    }, [iconRef?.current])

    const handleMenuClick = () => {
        setMenuOpen(true);
        if (onHamburgerClick) onHamburgerClick(); // Optional external click handler
    };

    const handleClose = () => {
        setMenuOpen(false);
    };


    return (
        <>
            <div className="headerContent" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header" style={{ width: `calc(100vw - ${iconWidth}px)` }}>
                    {showHamburger ? (
                        <MenuIcon
                            onClick={handleMenuClick}
                            style={{ color: '#fff', width: '30px', height: '30px' }}
                        />
                    ) : (
                        showBackArrow && (
                            <ArrowBackIcon
                                onClick={onBackClick}
                                style={{ color: '#fff', width: '30px', height: '30px' }}
                            />
                        )
                    )}
                    <div style={{ display: 'flex', flexDirection: 'column', justifyItems: 'center', width: `calc(100vw - ${iconWidth}px - 60px)` }}>
                        <span className="header-text">{headerText}</span>
                        {subHeader !== '' && <span className="SubHeader-text">{subHeader}</span>}
                    </div>
                </div>
                {icons.length > 0 &&
                    <div className="icons-container" ref={iconRef}>
                        {icons.map((item) => (
                            <span onClick={() => {
                                item.callback && item.callback()
                            }}
                                style={{ display: 'flex',alignItems:'center' }}
                            >
                                {item.icon}{item?.label || ''}
                            </span>
                        ))}
                    </div>
                }
            </div>

            {/* Mobile Menu */}
            <MobileMenu menuOpen={menuOpen} onClose={handleClose} />
        </>
    );
};

export default ModalHeader;
